import abbreviate from './abbreviate';

export { abbreviate };

export const randomNumberFromRange = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min);

export const sequenceFromRange = (start: number, stop: number, step = 1) =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const toFixedNumber = (number: number, decimals = 2) => number.toFixed(decimals);

export default { abbreviate, randomNumberFromRange, sequenceFromRange, toFixedNumber };
